export default __webpack_public_path__ + "static/media/timer.9bc1d852.svg";